import { createAction, props } from '@ngrx/store';
import { ErrorInterface } from '../../../@core/interfaces/general.interface';
import { ResponseUserInterface } from '../../../admin/dashboard/interfaces/user.inferfaces';

enum ClientUserActionType {
  loadUser = '[client user] get User',
  changeStatusUser = '[client user] changeStatus User',
  requestSuccess = '[client user] success User',
  requestError = '[client user] error User',
  clearUser = '[client user] clear User',
}

export const loadUser = createAction(
  ClientUserActionType.loadUser,
  props<{ id: number }>()
);

export const changeStatusUser = createAction(
  ClientUserActionType.changeStatusUser,
  props<{ id: number; status: string }>()
);

export const requestSuccess = createAction(
  ClientUserActionType.requestSuccess,
  props<{ response: ResponseUserInterface }>()
);

export const requestError = createAction(
  ClientUserActionType.requestError,
  props<{ error: ErrorInterface }>()
);

export const clearUser = createAction(ClientUserActionType.clearUser);
